// extracted by mini-css-extract-plugin
module.exports = {"advanced":"styles_advanced__20AnM"};